import React from 'react'
import './Enquire_now_btn.css'
import { Link } from 'react-router-dom'

const Enquire_now_btn = () => {
    return (
        <>
            <section className='enquiresec'>
                <Link to='/registration'>
                    <button className='enquire_now_btn'>Enquire Now</button>
                </Link>
            </section>
        </>
    )
}

export default Enquire_now_btn